import { atom as t } from "jotai";
const l = t(null);
t((o) => o(l));
const n = t(null, (o, e, m) => {
  e(l, m);
});
export {
  l as alertAtom,
  n as setAlertAtom
};
